const LesothoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111752)">
      <path
        d="M0 19.9998C0 23.1162 0.713047 26.0661 1.98453 28.6954L20 29.565L38.0155 28.6955C39.287 26.0661 40 23.1162 40 19.9998C40 16.8834 39.287 13.9336 38.0155 11.3042L20 10.4346L1.98453 11.3041C0.713047 13.9336 0 16.8834 0 19.9998H0Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#6DA544"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#0052B4"
      />
      <path
        d="M21.3044 19.5658V14.7832H18.6957V19.5658L15.5449 22.7166C16.4613 24.2166 18.1137 25.218 20.0001 25.218C21.8865 25.218 23.5388 24.2166 24.4552 22.7166L21.3044 19.5658Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111752">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LesothoSvg;
